import * as Sentry from "@sentry/vue";

export default {
    install(Vue){
        Vue.prototype.$catchError = (error) => { Sentry.captureException(error) }
    }
};
